import { createFileRoute } from '@tanstack/react-router'
import { AcquiredUsersPage } from '@/features/acquired-users'

export const Route = createFileRoute('/_authenticated/acquired-users/')({
  component: AcquiredUsersPage,
})
